import {Component, inject, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from "rxjs";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {FieldConfig, FieldType} from "../../../../shared/components/dynamic-forms-components/field.interface";
import {Actions} from "@ngrx/effects";
import {DynamicFormService} from "../../../../shared/components/dynamic-forms-components/dynamic-form.service";
import {Store} from "@ngrx/store";
import {AppState} from "../../../../store/reducers";
import {
  otpPhoneNumbervalidator,
  passwordPolicyValidator,
  phoneNumbervalidator
} from "../../../../shared/validators/input-validators";
import {Router} from "@angular/router";
import {createCitizenMutation} from "../../../../store/entities/citizens/register/citizens/citizens.actions";
import {CitizenTypeInum} from "../../../../store/entities/citizens/register/citizens/citizens.model";
import {
  BARUA_PEPE_VALIDATOR,
  EMAIL_VALIDATOR,
  NIN_VALIDATOR
} from "../../../../shared/components/dynamic-forms-components/custom-validators";
import {NotificationService} from "../../../../services/notification.service";

@Component({
  selector: 'app-citizen-registration',
  templateUrl: './citizen-registration.component.html',
  styleUrl: './citizen-registration.component.scss'
})
export class CitizenRegistrationComponent implements OnInit, OnDestroy {
  form: FormGroup;
  subscription$: Subscription = new Subscription();
  hidePassword = true;
  hideConfirmPassword = true;

  constructor(
    private fb: FormBuilder,
    private store: Store<AppState>,
    private router: Router,
    private notificationService: NotificationService
  ) {}

  ngOnInit(): void {
    this.form = this.fb.group(
      {
        userFirstName: ['', Validators.required],
        userLastName: ['', Validators.required],
        userNidaNumber: ['', [Validators.required, NIN_VALIDATOR.validator]],
        profilePhone: ['', [Validators.required, Validators.pattern(phoneNumbervalidator)]],
        userEmail: ['', [Validators.required, BARUA_PEPE_VALIDATOR.validator]],
        userPassword: ['', [Validators.required, passwordPolicyValidator()]],
        confirmPassword: ['', [Validators.required, passwordPolicyValidator()]],
        consent: [false, Validators.requiredTrue],
      },
      { validator: this.matchPasswords('userPassword', 'confirmPassword') }
    );
  }

  ngOnDestroy(): void {
    this.subscription$.unsubscribe();
  }

  async submitForm() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const input = this.form.value;
    const formData = {
      citizenType: CitizenTypeInum.Local,
      userPassword: input.userPassword,
      userFirstName: input.userFirstName,
      userLastName: input.userLastName,
      userNidaNumber: input.userNidaNumber,
      userEmail: input.userEmail,
      profilePhone: input.profilePhone,
    };

    this.store.dispatch(createCitizenMutation({ input: formData }));
  }

  matchPasswords(passwordKey: string, confirmPasswordKey: string) {
    return (formGroup: FormGroup) => {
      const password = formGroup.get(passwordKey);
      const confirmPassword = formGroup.get(confirmPasswordKey);

      if (!password || !confirmPassword) return null;

      if (confirmPassword.errors && !confirmPassword.errors['passwordMismatch']) {
        return null;
      }

      if (password.value !== confirmPassword.value) {
        confirmPassword.setErrors({ passwordMismatch: true });
      } else {
        confirmPassword.setErrors(null);
      }
      return null;
    };
  }
  seraYaFaraghaText: string = `
  Kwa ridhaa yangu ninakubaliana na ukusanyaji, matumizi, na uhifadhi wa taarifa zangu binafsi kulingana na
  <a href=\"/privacy-policy\" target=\"_blank\" class=\"underline text-primary-600\">Sera ya Ulinzi wa Taarifa Binafsi</a>.
  Taarifa zako zitahifadhiwa kwa usalama na zitatumika kwa madhumuni yaliyoelezwa pekee.
  Una haki ya kufikia, kusasisha taarifa zako wakati wowote.
`;

}
